import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdOutlineEmail } from 'react-icons/md'
import ReactSelect from 'react-select'

import EmailChipInput from '@component/FollowUpFornecedor/EmailChipInput'
import FuModalHeader from '@component/FollowUpFornecedor/ModalHeader'

import { IEditConfigPayload } from '@base/@types/providers/FollowUpFornecedor/ConfigProvider'

interface Props {
  isOpen: boolean
  editForm: IEditConfigPayload
  setEditForm: (fn: (f: IEditConfigPayload) => IEditConfigPayload) => void
  supplierOptions: { value: any; label: string }[]
  centerOptions: { value: any; label: string }[]
  loadingFilters: boolean
  onClose: () => void
  onUpdate: () => void
}

const EditModal: FC<Props> = ({
  isOpen,
  editForm,
  setEditForm,
  supplierOptions,
  centerOptions,
  loadingFilters,
  onClose,
  onUpdate
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    scrollBehavior="inside"
    motionPreset="slideInBottom"
    size="xl"
  >
    <ModalOverlay />
    <ModalContent>
      <FuModalHeader icon={MdOutlineEmail} title="Editar Configuração" />
      <ModalCloseButton color="white" />
      <ModalBody bg="white" py={5}>
        <FormControl mb={4} isRequired>
          <FormLabel fontSize="sm">
            E-mail(s) de contato
            <Text
              as="span"
              fontSize="11px"
              color="gray.500"
              ml={2}
              fontWeight="normal"
            >
              (tecle Enter ou vírgula para adicionar)
            </Text>
          </FormLabel>
          <EmailChipInput
            value={editForm.emails}
            onChange={emails => setEditForm(f => ({ ...f, emails }))}
          />
        </FormControl>
        <FormControl mb={4} isRequired>
          <FormLabel fontSize="sm">Fornecedor(es)</FormLabel>
          <ReactSelect
            isMulti
            isLoading={loadingFilters}
            options={supplierOptions}
            value={supplierOptions.filter(o =>
              editForm.supplierIds.map(String).includes(String(o.value))
            )}
            placeholder="Selecionar fornecedor(es)..."
            onChange={opts =>
              setEditForm(f => ({
                ...f,
                supplierIds: (opts as any[]).map(o => Number(o.value))
              }))
            }
          />
        </FormControl>
        <FormControl isRequired>
          <HStack justify="space-between" mb={1}>
            <FormLabel fontSize="sm" mb={0}>
              Centro(s)
            </FormLabel>
            <Text
              fontSize="11px"
              color={
                centerOptions.length === 0 || loadingFilters
                  ? 'gray.300'
                  : 'green.600'
              }
              fontWeight="600"
              cursor={
                centerOptions.length === 0 || loadingFilters
                  ? 'not-allowed'
                  : 'pointer'
              }
              userSelect="none"
              onClick={() => {
                if (centerOptions.length === 0 || loadingFilters) return
                const allSelected =
                  editForm.storeIds.length === centerOptions.length
                setEditForm(f => ({
                  ...f,
                  storeIds: allSelected
                    ? []
                    : centerOptions.map(o => Number(o.value))
                }))
              }}
            >
              {editForm.storeIds.length === centerOptions.length &&
              centerOptions.length > 0
                ? 'Desmarcar Todos'
                : 'Selecionar Todos'}
            </Text>
          </HStack>
          <ReactSelect
            isMulti
            isLoading={loadingFilters}
            options={centerOptions}
            value={centerOptions.filter(o =>
              editForm.storeIds.map(String).includes(String(o.value))
            )}
            placeholder="Selecionar centro(s)..."
            onChange={opts =>
              setEditForm(f => ({
                ...f,
                storeIds: (opts as any[]).map(o => Number(o.value))
              }))
            }
          />
        </FormControl>
      </ModalBody>
      <ModalFooter
        bg="white"
        borderBottomLeftRadius={5}
        borderBottomRightRadius={5}
      >
        <Button colorScheme="blue" mr={3} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          bg="green.600"
          color="white"
          _hover={{ bg: 'green.500' }}
          _active={{ bg: 'green.500' }}
          isDisabled={
            editForm.emails.length === 0 ||
            editForm.supplierIds.length === 0 ||
            editForm.storeIds.length === 0
          }
          onClick={onUpdate}
        >
          Salvar
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)

export default EditModal
